module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "notifications-template"
    }
  }, [_c('v-breadcrumbs', {
    attrs: {
      "items": [{
          text: 'Dashboard',
          to: {
            path: '/'
          }
        },
        {
          text: 'Generate Activation',
          to: {
            path: '/code-activation'
          },
        },
        {
          text: 'Tambah Kode Aktivasi'
        } ],
      "divider": "|"
    }
  }), _vm._v(" "), _c('h3', {
    staticClass: "header-text font-weight-bold"
  }, [_vm._v("Tambah Kode Aktivasi")]), _vm._v(" "), _c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-title', [_vm._v("\n            Tambah Kode Aktivasi "), _c('v-spacer')], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-text', [(_vm.page === 'form') ? [_c('v-form', {
    ref: "form"
  }, [_c('div', {
    staticClass: "mb-2 mt-4"
  }, [_c('v-list-item', {
    staticClass: "pa-0",
    attrs: {
      "two-line": ""
    }
  }, [_c('v-list-item-content', {
    staticClass: "pa-0"
  }, [_c('v-list-item-title', {
    staticClass: "font-weight-bold pb-2"
  }, [_vm._v("\n                                    Jumlah User *\n                                ")]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "placeholder": "Jumlah User",
      "outlined": "",
      "required": "",
      "rules": [
        function (v) { return !!v ||
        'Jumlah user wajib diisi'; } ]
    },
    model: {
      value: (_vm.form.count),
      callback: function($$v) {
        _vm.$set(_vm.form, "count", $$v)
      },
      expression: "form.count"
    }
  })], 1)], 1), _vm._v(" "), _c('v-list-item', {
    staticClass: "pa-0",
    attrs: {
      "two-line": ""
    }
  }, [_c('v-list-item-content', {
    staticClass: "pa-0"
  }, [_c('v-list-item-title', {
    staticClass: "font-weight-bold pb-2"
  }, [_vm._v("\n                                    Durasi *\n                                ")]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "placeholder": "Durasi (Bulan)",
      "outlined": "",
      "rules": [
        function (v) { return !!v || 'Durasi wajib diisi'; } ]
    },
    model: {
      value: (_vm.form.duration),
      callback: function($$v) {
        _vm.$set(_vm.form, "duration", $$v)
      },
      expression: "form.duration"
    }
  })], 1)], 1), _vm._v(" "), _c('v-list-item', {
    staticClass: "pa-0",
    attrs: {
      "two-line": ""
    }
  }, [_c('v-list-item-content', {
    staticClass: "pa-0"
  }, [_c('v-list-item-title', {
    staticClass: "font-weight-bold pb-2"
  }, [_vm._v("\n                                    Jenjang *\n                                ")]), _vm._v(" "), _c('div', _vm._l((_vm.level_list), function(data, index) {
    return _c('v-btn', {
      key: index,
      staticClass: "mb-5 mr-2",
      attrs: {
        "depressed": "",
        "rounded": "",
        "width": "60",
        "color": _vm.level === data ? 'success' : ''
      },
      on: {
        "click": function($event) {
          _vm.level = data
        }
      }
    }, [_vm._v("\n                                        " + _vm._s(data) + "\n                                    ")])
  }), 1)], 1)], 1), _vm._v(" "), _c('v-list-item', {
    staticClass: "pa-0",
    attrs: {
      "two-line": ""
    }
  }, [_c('v-list-item-content', {
    staticClass: "pa-0"
  }, [_c('v-list-item-title', {
    staticClass: "font-weight-bold pb-2"
  }, [_vm._v("\n                                    Kelas *\n                                ")]), _vm._v(" "), _c('div', _vm._l((_vm.grade_list), function(data, index) {
    return _c('v-btn', {
      key: index,
      staticClass: "mb-5 mr-2",
      attrs: {
        "depressed": "",
        "rounded": "",
        "width": "50",
        "color": _vm.grade === data ? 'primary' : ''
      },
      on: {
        "click": function($event) {
          _vm.grade = data
        }
      }
    }, [_vm._v("\n                                        " + _vm._s(data) + "\n                                    ")])
  }), 1)], 1)], 1), _vm._v(" "), _c('v-list-item', {
    staticClass: "pa-0",
    attrs: {
      "two-line": ""
    }
  }, [_c('v-list-item-content', {
    staticClass: "pa-0"
  }, [_c('v-list-item-title', {
    staticClass: "font-weight-bold pb-2"
  }, [_vm._v("\n                                    Paket *\n                                ")]), _vm._v(" "), _c('v-autocomplete', {
    staticClass: "pa-0",
    attrs: {
      "placeholder": "Pilih Paket",
      "outlined": "",
      "items": _vm.data_package,
      "item-text": "name",
      "item-value": "id",
      "rules": [
        function (v) { return !!v || 'Paket wajib diisi'; } ]
    },
    model: {
      value: (_vm.form.package_id),
      callback: function($$v) {
        _vm.$set(_vm.form, "package_id", $$v)
      },
      expression: "form.package_id"
    }
  })], 1)], 1), _vm._v(" "), _c('v-list-item', {
    staticClass: "pa-0",
    attrs: {
      "two-line": ""
    }
  }, [_c('v-list-item-content', {
    staticClass: "pa-0"
  }, [_c('v-list-item-title', {
    staticClass: "font-weight-bold pb-2"
  }, [_vm._v("\n                                    Platform *\n                                ")]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "placeholder": "Platform",
      "outlined": "",
      "rules": [
        function (v) { return !!v || 'Platform wajib diisi'; } ]
    },
    model: {
      value: (_vm.form.platform),
      callback: function($$v) {
        _vm.$set(_vm.form, "platform", $$v)
      },
      expression: "form.platform"
    }
  })], 1)], 1), _vm._v(" "), _c('v-list-item', {
    staticClass: "pa-0",
    attrs: {
      "two-line": ""
    }
  }, [_c('v-list-item-content', {
    staticClass: "pa-0"
  }, [_c('v-list-item-title', {
    staticClass: "font-weight-bold pb-2"
  }, [_vm._v("\n                                    Tanggal Expired *\n                                ")]), _vm._v(" "), _c('v-menu', {
    ref: "menu",
    attrs: {
      "close-on-content-click": false,
      "transition": "slide-y-reverse-transition",
      "offset-y": "",
      "min-width": "auto"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;
        var attrs = ref.attrs;

        return [_c('v-text-field', _vm._g(_vm._b({
          attrs: {
            "append-icon": "mdi-calendar",
            "placeholder": "Tanggal Expired",
            "readonly": "",
            "outlined": "",
            "rules": [
              function (v) { return !!v ||
              'Tanggal expired wajib diisi'; } ]
          },
          model: {
            value: (_vm.form.expired_at),
            callback: function($$v) {
              _vm.$set(_vm.form, "expired_at", $$v)
            },
            expression: "form.expired_at"
          }
        }, 'v-text-field', attrs, false), on))]
      }
    }], null, false, 3628513452),
    model: {
      value: (_vm.date_expired),
      callback: function($$v) {
        _vm.date_expired = $$v
      },
      expression: "date_expired"
    }
  }, [_vm._v(" "), _c('v-date-picker', {
    attrs: {
      "no-title": "",
      "scrollable": ""
    },
    on: {
      "change": function($event) {
        _vm.date_expired = false
      }
    },
    model: {
      value: (_vm.form.expired_at),
      callback: function($$v) {
        _vm.$set(_vm.form, "expired_at", $$v)
      },
      expression: "form.expired_at"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-row', {
    staticClass: "pa-4"
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "mr-2",
    attrs: {
      "text": ""
    },
    on: {
      "click": function($event) {
        return _vm.$router.push('/code-activation')
      }
    }
  }, [_vm._v("\n                            Batal\n                        ")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "depressed": "",
      "loading": _vm.isLoading
    },
    on: {
      "click": function($event) {
        return _vm.submitActivationCode()
      }
    }
  }, [_vm._v("\n                            Lanjut\n                        ")])], 1)], 1)] : _vm._e(), _vm._v(" "), (_vm.page === 'download') ? [_c('div', {
    staticClass: "text-center"
  }, [_c('div', {
    staticClass: "mb-5 mt-3 font-weight-bold black--text"
  }, [_vm._v("\n                        Anda telah berhasil menambahkan kode aktivasi\n                    ")]), _vm._v(" "), _c('v-btn', {
    staticClass: "font-weight-bold",
    staticStyle: {
      "color": "#2690cb"
    },
    attrs: {
      "id": "datatable_detail_btn",
      "depressed": "",
      "large": "",
      "color": "#E8F5FA"
    },
    on: {
      "click": function($event) {
        return _vm.downloadFile()
      }
    }
  }, [_c('v-icon', {
    staticClass: "mr-2"
  }, [_vm._v(" mdi-tray-arrow-down ")]), _vm._v("\n                        Download Kode Aktivasi\n                    ")], 1)], 1), _vm._v(" "), _c('v-row', {
    staticClass: "pa-4"
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "depressed": ""
    },
    on: {
      "click": function($event) {
        return _vm.$router.push('/code-activation')
      }
    }
  }, [_vm._v("\n                        Selesai\n                    ")])], 1)] : _vm._e()], 2)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-201833f7","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/modules/code_activation/components/CodeActivationForm.vue
// module id = 2180
// module chunks = 1